import styled from "styled-components";
const isMobile = window.innerWidth < 768;

export const StyledAuth = styled.div`
    height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 50px;
    padding-top: ${isMobile ? '60px'  : '160px' };
    background-color: rgba(251, 247, 240, 1);
`
export const GoogleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  padding: 10px 20px;
  border-radius: 12px;
  border: 1.5px solid rgba(150, 155, 171, 0.35);
  background: #fff;
  color: #0A033C;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.15s, box-shadow 0.15s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.10);
  }
  &:active { transform: translateY(0); }
  .anticon { font-size: 20px; }
`;

export const Divider = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  color: #969BAB;
  font-size: 14px;

  &::before, &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: rgba(150, 155, 171, 0.35);
  }
`;